import { useEffect, useState } from "react";
import style from "./style.module.scss";
import HomeHeader from "layouts/homeHeader";
import HomeNavbar from "layouts/homeNavbar";
import BigUserIcon from "assets/icons/biguser.svg";
import Input from "components/UI/Input";
import LockIcon from "assets/icons/lockpick.svg";
import PencilIcon from "assets/icons/pencil-icon.svg";
import BackgroundImage from "assets/images/header.webp";
import SettingsIcon from "assets/icons/setting.svg";
import ChatIcon from "assets/icons/chat.svg";
import AnnouncementIcon from "assets/icons/announcement.svg";
import HamburgerIcon from "assets/icons/hamburger.svg";
import DoneIcon from "assets/icons/done-icon.svg";
import CloseIcon from "assets/icons/close-icon.svg";
import axios from "axios";
import { useKeycloak } from "@react-keycloak/web";
import LoaderSpinner from "../../components/UI/LoaderSpinner/LoaderSpinner";
import { UserModelResponse } from "types";
import AuthService from "services/AuthService";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify'
import { locationController } from "utils/locationhelper";

const UserOperationsPage = () => {
  const [password, setPassword] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { keycloak } = useKeycloak();
  const [user, setUser] = useState<UserModelResponse>(null!);

  const auth = new AuthService(keycloak);
  
  let companyId = locationController();

  const getUserInfo = async() => {
    setIsLoading(true);

    auth.axios(`/User/GetUserInfo`, null, {
      username: keycloak?.tokenParsed?.preferred_username,
      companyId: companyId
    }).then((response) => {
        setIsLoading(false);
        if (response.data.success === true) {
          setUser(response.data.data);
          setPhoneNumber(response.data?.data?.phone);
        } else {
          if (response.data.message) {
            toast.error(response.data.message, {
              position: toast.POSITION.TOP_RIGHT,
              theme: "colored",
            });
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);

        toast.error(err.response.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          theme: "colored",
        });
      });
       
  }

  useEffect(() => {
    getUserInfo()
  }, []);

 const updatePhoneNumber = async() =>{
  setIsLoading(true);



  auth.axios(`/User/UpdateUserPhoneNumber`, null, {
    username: keycloak?.tokenParsed?.preferred_username,
    phoneNumber: phoneNumber,
    companyId: companyId
  })
  .then((response) => {
      setIsLoading(false);
      if (response.data.success === true) {
        
      } else {

        if (response.data.message) {
          toast.error(response.data.message, {
            position: toast.POSITION.TOP_RIGHT,
            theme: "colored",
          });
        }

      }
    })
    .catch((err) => {
      setIsLoading(false);

      toast.error(err.response.data.message, {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
      });

    });
 }

  return (
    <div>
      <ToastContainer/>
      <div className={style.userOperations}>
        <div className={style.left}>
          <HomeNavbar />
        </div>
        <div className={style.right}>
          <HomeHeader
            personal="#fff"
            hamburgerIcon={HamburgerIcon}
            announcementIcon={AnnouncementIcon}
            chatIcon={ChatIcon}
            settingsIcon={SettingsIcon}
            title="Kullanıcı İşlemleri"
            background={BackgroundImage}
            color={"#fff"}
          />
          <div className={style.content}>
            <div className={style.leftBox}>
              <img src={BigUserIcon} className={style.icon} alt="" />
              <div className={style.headerText}>Kullanıcı Bilgileri</div>
              <div className={style.userInformation}>
                <div className={style.infoArea}>
                  <div className={style.leftText}>Kullanıcı Adı</div>
                  <div className={style.centerText}>:</div>
                  <div className={style.rightText}>{user?.username}</div>
                </div>
                {/* <div className={style.infoArea}>
                  <div className={style.leftText}>Müşteri Numarası</div>
                  <div className={style.centerText}>:</div>
                  <div className={style.rightText}>0001689452163</div>
                </div> */}
                <div className={style.infoArea}>
                  <div className={style.leftText}>Müşteri Adı</div>
                  <div className={style.centerText}>:</div>
                  <div className={style.rightText}>{user?.name}</div>
                </div>
                <div className={style.infoArea}>
                  <div className={style.leftText}>Müşteri Soyadı</div>
                  <div className={style.centerText}>:</div>
                  <div className={style.rightText}>{user?.surname}</div>
                </div>
                {/* <div className={style.infoArea}>
                  <div className={style.leftText}>Abone Adresi</div>
                  <div className={style.centerText}>:</div>
                  <div className={style.rightText}>
                    Beşevler Mh. Çankaya Cd. No:56 Keçiören/ANKARA
                  </div>
                </div> */}
                <div className={style.infoArea}>
                  <div className={style.leftText}>E mail Adresi</div>
                  <div className={style.centerText}>:</div>
                  <div className={style.rightText}>{user?.email}</div>
                </div>
                <div className={style.infoArea}>
                  <div className={style.leftText}>Telefon Numarası</div>
                  <div className={style.centerText}>:</div>
                  <div className={style.rightText}>
                    {editMode ? (
                      <>
                        <input
                          value={phoneNumber}
                          onChange={(e: any) => setPhoneNumber(e.target.value)}
                          autoFocus
                          maxLength={11}
                        />
                        <img
                          className={style.doneIcon}
                          onClick={() => {
                            setEditMode(false);
                            updatePhoneNumber();
                          }}
                          src={DoneIcon}
                        />
                        <img
                          className={style.closeIcon}
                          src={CloseIcon}
                          onClick={() => {
                            setEditMode(false);
                          }}
                        ></img>
                      </>
                    ) : (
                      <div>
                        {phoneNumber}
                        <img
                          className={style.pencilIcon}
                          onClick={() => setEditMode(true)}
                          src={PencilIcon}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {isLoading ? <LoaderSpinner /> : ""}
            {/* <div className={style.rightBox}>
              <img src={LockIcon} className={style.icon} alt="" />
              <div className={style.headerText}>Güvenlik Ayarları</div>
              <div className={style.detailText}>
                Şifreniz en az bir harf, rakam veya özel karakter içermeli. Ayrıca
                şifreniz en az 8 karakterden oluşmalı.
              </div>
              <div className={style.newPassword}>
                <div className={style.passwordInput}>
                  <Input
                    label="Mevcut Şifreniz"
                    onChange={(e: any) => setPassword(e.target.value)}
                    placeholder="*******************"
                    type="password"
                    value={password}
                  />
                </div>
                <div className={style.passwordInput}>
                  <Input
                    label="Yeni Şifreniz"
                    onChange={(e: any) => setPasswordAgain(e.target.value)}
                    placeholder="*******************"
                    type="password"
                    value={passwordAgain}
                  />
                </div>
              </div>
              <div className={style.footerDetail}>
                Güvenliğiniz için adınız, soyadınız ve doğum tarihinizi içermeyen
                bir şifre belirleyin.
              </div>
              <button
                onClick={() => {
                  console.log("test");
                }}
                disabled={!password || !passwordAgain ? true : false}
                className={style.footerBtn}
              >
                Şifreyi Güncelle
              </button>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserOperationsPage;
